import { render, staticRenderFns } from "./IconAngle.vue?vue&type=template&id=456fb75d&scoped=true&"
import script from "./IconAngle.vue?vue&type=script&lang=js&"
export * from "./IconAngle.vue?vue&type=script&lang=js&"
import style0 from "./IconAngle.vue?vue&type=style&index=0&id=456fb75d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456fb75d",
  null
  
)

export default component.exports